export const CREATE_VOUCHER_ERROR = 'CREATE_VOUCHER_ERROR';
export const CREATE_VOUCHER_SUCCESS = 'CREATE_VOUCHER_SUCCESS';
export const CREATE_VOUCHER_START = 'CREATE_VOUCHER_START';
export const CLEAR_VOUCHER_ERROR = 'CLEAR_VOUCHER_ERROR';
export const CLEAR_VOUCHER_INFO = 'CLEAR_VOUCHER_INFO';
export const CREATE_VOUCHER_CLEAR = 'CREATE_VOUCHER_CLEAR';
